export default __webpack_public_path__ + "static/media/arrow-down.f68a72d5.svg";